module.exports = __webpack_public_path__ + "c5a2962e36ac4404f72138aafc222fa3.svg";